import Cookies, { CookieAttributes } from "js-cookie";
import {
  IBattingCageCookie,
  IBattingCagePreviewTriggersCookie,
} from "../types";
import { uriToJSON } from "./utils";

enum CookieType {
  BattingCage = "batting-cage-script-cookie",
  BattingCagePreviewTriggers = "batting-cage-preview-triggers",
}

enum OwnedAndOperatoedCookieType {
  InternalSessionId = "internal_session_id",
  UserIP = "currIp",
}

const inFifteenMinutes = () => new Date(new Date().getTime() + 15 * 60 * 1000);

const DefaultCookieValues = {
  [CookieType.BattingCage]: {
    meta: { internalSessionId: null },
    persistedExperience: null,
  },
  [CookieType.BattingCagePreviewTriggers]: [],
};

const cookie = <T>(cookieName: CookieType) => {
  const createAndReturnCookie = () => {
    Cookies.set(cookieName, JSON.stringify(DefaultCookieValues[cookieName]), {
      // batting-cage-script-cookie expires in 7 days
      expires: cookieName === CookieType.BattingCage ? 7 : inFifteenMinutes(),
    });

    return Cookies.get(cookieName);
  };
  const getOrCreateCookie = () => {
    const cookie = Cookies.get(cookieName);

    if (cookie) return cookie;

    return createAndReturnCookie();
  };

  const get: () => T = () => {
    const cookieValue = getOrCreateCookie();

    const defaultCookieValue = JSON.stringify(DefaultCookieValues[cookieName]);

    return uriToJSON(cookieValue || defaultCookieValue);
  };

  const set = ({
    value,
    options = {},
  }: {
    value: T;
    options?: CookieAttributes;
  }) =>
    Cookies.set(cookieName, JSON.stringify(value), {
      expires: cookieName === CookieType.BattingCage ? 7 : inFifteenMinutes(),
      ...options,
    });

  const remove = ({ options }: { options?: CookieAttributes }) =>
    Cookies.remove(cookieName, options);

  return {
    get,
    set,
    remove,
  };
};

export const BattingCageCookie = cookie<IBattingCageCookie>(
  CookieType.BattingCage
);

export const BattingCagePreviewTriggersCookie = cookie<
  IBattingCagePreviewTriggersCookie[]
>(CookieType.BattingCagePreviewTriggers);

export const InternalSessionIdCookie = {
  get: () => Cookies.get(OwnedAndOperatoedCookieType.InternalSessionId),
};

export const UserIPCookie = {
  get: () => Cookies.get(OwnedAndOperatoedCookieType.UserIP),
};
